import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getPreferences,
  IPref,
  setPreferences,
} from "../../api/concierges/preferences";

export const usePreferences = (id: string, page: string, divCode: string) => {
  return useQuery<{ [x: string]: IPref }>({
    queryKey: [`preferences-${id}${page}`, divCode],
    queryFn: () => getPreferences(id, page),
    enabled: !!id && !!page && !!divCode,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useSetPreferences = (
  id: string,
  page: string,
  divCode: string
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updatedPreferences: { [x: string]: IPref }) =>
      setPreferences(id, page, updatedPreferences),
    onSuccess: (_, updatedPreferences) => {
      // Full overwrite of cache if necessary
      // queryClient.setQueryData(
      //   [`preferences-${id}${page}`, divCode],
      //   updatedPreferences
      // );

      /**
       * going with a delta change as it's in line with Notes implementation and more optimized. 
       */
      queryClient.setQueryData(
        [`preferences-${id}${page}`, divCode],
        (oldData: { [x: string]: IPref } | undefined) => {
          if (!oldData) return updatedPreferences;
          const updatedDelta = { ...oldData };
          Object.keys(updatedPreferences).forEach((viewName) => {
            updatedDelta[viewName] = updatedPreferences[viewName];
          });
          Object.keys(oldData).forEach((viewName) => {
            if (!updatedPreferences.hasOwnProperty(viewName)) {
              delete updatedDelta[viewName];
            }
          });
          return updatedDelta;
        }
      );
    },
    onError: (error) => {
      console.error("Error updating preferences:", error);
    },
  });
};
